// extracted by mini-css-extract-plugin
export default {"summary":"styles_summary__486Qp","summary--disabled":"styles_summary--disabled__7yKvo","summary__inner":"styles_summary__inner__VsPRr"};